export const STOCK_GOOD_STATUS = '在庫あり'
